export default __webpack_public_path__ + "static/media/saveFilterBtn.10816edd.svg";